import React from 'react';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import makeStyles from '@material-ui/core/styles/makeStyles';
import selectiveMemoComparison from '../utils/selectiveMemoComparison';
import Button from '@material-ui/core/Button';

import Cookie from 'js-cookie';
import {useHistory} from 'react-router';
import {RoutesPaths} from '../environment';
import {useAppState} from '../app/AppState';
import {Theme} from '@material-ui/core';
import StarsFeedBack from './StarsFeedBack';

const useStyles = makeStyles((theme: Theme) => ({
  List: {
    padding: 8,
    boxShadow: '0 0 1px 1px rgba(0, 0, 0, 0.1)',
    [theme.breakpoints.down(740)]: {
      display: 'grid',
      alignContent: 'flex-start',
      gridTemplateColumns: '1fr 1fr',
      '& > *:first-child': {
        gridColumn: '-1/1'
      }
    },

  },
  ListSubheader: {
    color: '#666666',
    fontSize: 22,
    lineHeight: 1,
    padding: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  ListItem: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  ListItemTextMultiline: {
    marginBottom: 3,
    marginTop: 3,
  },
  ListItemTextPrimary: {
    fontSize: 18
  },
  ListItemTextSecondary: {
    fontSize: 18
  },
  ListItemExitButton: {
    marginTop: 10,
  }
}));

const PatientInfo = () => {
  const cl = useStyles();
  const history = useHistory();
  const appState = useAppState();
  const [client, setClient] = appState.client;
  const [, setOrders] = appState.orders;

  const handleLogout = () => {
    setClient(null);
    setOrders(null);
    Cookie.remove('accessKey');
    history.push(RoutesPaths.Auth);
  };

  if (client === null) return <div className={cl.List} />;
  return (
    <List
      dense
      className={cl.List}
      subheader={<ListSubheader disableSticky className={cl.ListSubheader}>
        Інформація про пацієнта
      </ListSubheader>}
    >

      <MemoListItem label="Прізвище" value={client.secondName} />
      <MemoListItem label="Ім'я" value={client.firstName} />
      <MemoListItem label="По-Батькові" value={client.middleName} />
      <MemoListItem label="Стать" value={client.gender} />
      <MemoListItem label="Дата народження" value={client.birthday} />
      <MemoListItem label="Вік" value={client.age} />
      <MemoListItem label="Телефон" value={client.phoneNumber} />
      <ListItem className={cl.ListItemExitButton}>
        <Button
          onClick={handleLogout}
          size="small"
          variant="contained"
          color="secondary"

        >
          Вихід
        </Button>
      </ListItem>
        <ListItem>
        <StarsFeedBack />
      </ListItem>
    </List>
  );
};

export default PatientInfo;


const MemoListItem = selectiveMemoComparison((props: { label: string, value: string }) => {
  const cl = useStyles();
  return (
    <ListItem className={cl.ListItem}>
      <ListItemText
        classes={{
          primary: cl.ListItemTextPrimary,
          secondary: cl.ListItemTextSecondary,
          multiline: cl.ListItemTextMultiline
        }}
        primary={props.label + ':'}
        secondary={props.value}
      />
    </ListItem>
  );

})(p => p.value, p => p.label);
